export default __webpack_public_path__ + "static/sdfcu-a16e1d9a52711b5279f0af743fb9e5f2.png";